import React, { useState } from "react";
import { Col, Row } from "reactstrap";

interface RowData {
  value: boolean; // Update type to boolean since we are toggling the state
  label: string;
}

interface Props {
  contentJSON: RowData[];
}

const CheckboxBasedButton: React.FC<Props> = ({ contentJSON }) => {
  const [selectedValues, setSelectedValues] = useState<boolean[]>(
    contentJSON.map((row) => row.value)
  );

  const handleSelection = (index: number) => {
    setSelectedValues((prev) =>
      prev.map((selected, i) => (i === index ? !selected : selected))
    );
  };

  return (
    <div className="checkbox-group-gateway" >
      <Row className="checkbox-button-group" >
        {contentJSON.map((row, index) => (
          <Col xs="auto" key={index} className="checkbox-group">
            <button
              type="button"
              className={`checkbox-button ${selectedValues[index] ? "selected" : ""
                }`}
              onClick={() => handleSelection(index)}
            >
              {row.label}
            </button>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CheckboxBasedButton;
